<div *commonUiOptionalWizardStep id="beginntaetigkeitwjstammkapitalangaben">
  <div *ngIf="!isKapGAus" class="d-flex justify-content-between mb-3x">
    <h2>{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.TITEL' | translate }}</h2>
  </div>
  <div *ngIf="isKapGAus" class="d-flex justify-content-between mb-3x">
    <h2>{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.DAUER_DER_TAETIGKEIT_IN_DER_BUNDESREPUBLIK_DEUTCHLAND' | translate }}</h2>
  </div>

  <div class="mb-5x">
    <common-ui-beginn-taetigkeit-angaben
      [(data)]="data.taetigkeitBeginnAngabe" [beginnDerTaetigkeitStammdaten]="stammdaten?.unternehmen?.beginnTaetigkeit"
      [readonly]="readonly">
    </common-ui-beginn-taetigkeit-angaben>
  </div>

  <div class="mb-5x">
    <div class="d-flex justify-content-between">
      <h2>{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.EROEFFNUNGSBILLANZ_WIRTSCHAFTSJAHR_TITEL' | translate }}
      </h2>
      <common-ui-daten-uebernahme (picked)="onWirtschaftsjahrPicked()"
                                  [itemTemplate]="datenuebernahmeWirtschaftsjahr"
                                  [items]="wirtschaftsJahrStammdaten" [readonly]="readonly"
                                  context="Wirtschaftsjahr"></common-ui-daten-uebernahme>
    </div>
    <common-ui-wirtschatsjahr-angaben [(data)]="data.eroeffnungsbilanzWjAngabe" [readonly]="readonly">
    </common-ui-wirtschatsjahr-angaben>
  </div>

  <div class="mb-5x">
    <common-ui-hoehe-grund-stammkapital-angabe
      [(data)]="data.grundStammkapitalAngabe" [readonly]="readonly">
    </common-ui-hoehe-grund-stammkapital-angabe>
  </div>

</div>

<ng-template #datenuebernahmeWirtschaftsjahr let-item="item">
  <div *ngIf="item.isAbweichend">
    <h4
      class="list-group-item-heading">{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.STAMMDATEN_NONSTANDARD_YEAR_TITEL' | translate }}</h4>
    <p class="list-group-item-text"> {{item?.von}} - {{item?.bis}}</p>
  </div>
  <div *ngIf="!item.isAbweichend">
    <h4
      class="list-group-item-heading">{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.STAMMDATEN_STANDARD_YEAR_TITEL' | translate }}</h4>
  </div>
</ng-template>
